import { MarcacaoResolver } from "./resolvers/_marcacao-resolvers";

export const MarcacaoServices = [
  MarcacaoResolver
]

